import { GzDialogWebComponent } from 'apps/webcomponents/src/ui/gzDialog';
import { GzDialog } from 'apps/webcomponents/src/ui/gzDialog/component/GzDialog';
import {
  attachDialogFooterListeners,
  getRestoreOriginalDialogButtons
} from '../shared/dialogUtils';

export class RestoreOriginalDialog {
  static open(translateFn: Function): GzDialogWebComponent {
    const bodyContent = translateFn('The emails and all their attached files will be sent to the intended recipients.');

    const footerContent = getRestoreOriginalDialogButtons(translateFn);
    const dialogConfigs: GzDialog = {
      headline: translateFn('Restore selected items?'),
      bodyContent,
      isOpen: true,
      footerContent,
    };

    const dialog = GzDialogWebComponent.buildDialogElement(dialogConfigs);

    attachDialogFooterListeners(footerContent, dialog);

    return dialog;
  }
}
